import type { AnimationName, AnimationPreset } from '@/js/modules/animate/types';
import { ANIMATION_NAMES } from '@/js/modules/animate/types';

const OFFSET_PX = 10;
const SCALE_FROM = 0.92;

const ZOOM_FROM = 1.05;

export const ANIMATION_PRESETS: Record<AnimationName, AnimationPreset> = {
  'fade-in': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  'fade-up': {
    from: { opacity: 0, y: OFFSET_PX },
    to: { opacity: 1, y: 0 },
  },
  'fade-down': {
    from: { opacity: 0, y: -OFFSET_PX },
    to: { opacity: 1, y: 0 },
  },
  'fade-left': {
    from: { opacity: 0, x: OFFSET_PX },
    to: { opacity: 1, x: 0 },
  },
  'fade-right': {
    from: { opacity: 0, x: -OFFSET_PX },
    to: { opacity: 1, x: 0 },
  },
  'scale-in': {
    from: { opacity: 0, scale: SCALE_FROM },
    to: { opacity: 1, scale: 1 },
  },
  'scale-half': {
    from: { opacity: 0, scale: 0.5 },
    to: { opacity: 1, scale: 1 },
  },
  'shutter-down': {
    from: { clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', overflow: 'hidden' },
    to: { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' },
  },
  'zoom-in': {
    from: { scale: ZOOM_FROM },
    to: { scale: 1 },
  },
  'box-drop': {
    from: { yPercent: -OFFSET_PX, opacity: 0 },
    to: { yPercent: 0, opacity: 1 },
  },
};

export function mergePresets(names: AnimationName[]): AnimationPreset {
  const from: AnimationPreset['from'] = {};
  const to: AnimationPreset['to'] = {};

  for (const name of names) {
    Object.assign(from, ANIMATION_PRESETS[name].from);
    Object.assign(to, ANIMATION_PRESETS[name].to);
  }

  return { from, to };
}

export function assertAnimationPresets(): void {
  const missing = ANIMATION_NAMES.filter(name => !Object.hasOwn(ANIMATION_PRESETS, name));

  if (missing.length > 0)
    throw new Error(`animate: missing preset for ${missing.join(', ')}`);
}
